import {
  object,
  string,
  array,
  number,
  boolean,
  SchemaOf,
  StringSchema,
} from 'yup';

import { DockerSetupFormValues } from './types';

export function createDockerSetupValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<DockerSetupFormValues> {
  return object({
    name: nameValidation,
    environmentGroupIds: array(number().required()),
    enableHostManagementFeatures: boolean().required(),
    allowVolumeBrowserForRegularUsers: boolean().required(),
    enableGpuManagement: boolean().required(),
    enableImageNotification: boolean().required(),
    gpus: array(
      object({
        value: string().required(),
        name: string().required(),
      })
    ).required(),
    changeWindow: object({
      Enabled: boolean().required(),
      StartTime: string().required(),
      EndTime: string().required(),
    }).required(),
  });
}
